<template>
    <v-container class="unauthorized fill-height" fluid>
        <v-row class="unauthorized__login" align="center" justify="center">
            <v-col cols="12" md="8">
                <v-card raised class="mx-auto" max-width="550px">
                    <v-card-title class="headline">SFS Portal</v-card-title>
                    <v-card-subtitle class="font-weight-medium">King's University College</v-card-subtitle>
                    <v-card-text class="text--primary">
                        <v-alert border="left" :color="warningColor" prominent type="warning">
                            Student Finance Service Portal is under maintenance.<br />
                            Please contact Student Finance at 
                            <a href="mailto:studentfinance@kings.uwo.ca">studentfinance@kings.uwo.ca</a> or 
                            <a href="tel:519-433-3491">519-433-3491</a> ext. 4319 
                            if you have any urgent issues regarding finance services.
                        </v-alert>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'unauthorized',
    computed: {
        warningColor() {
            return '#FF8F00'
        }
    }
}
</script>

<style scoped>
.headline {
    word-break: normal;
}

.unauthorized {
    background-image: url('../../assets/backgrounds/SLC-fall.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
}
</style>